import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { LEGAL_DOCS, LEGAL_EFFECTIVE } from "../legalContent";

// Accepts either a `doc` prop or a `:doc` route param.
const Legal = ({ doc: docProp }) => {
  const params = useParams();
  const key = docProp || params.doc;
  const doc = LEGAL_DOCS[key];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [key]);

  return (
    <div className="min-h-screen bb-bg text-white relative overflow-x-hidden">
      <div className="absolute inset-0 grid-pattern pointer-events-none opacity-20"></div>
      <div className="relative z-10">
        <Header />
        <main className="max-w-[820px] mx-auto px-4 lg:px-8 pt-28 pb-16" data-testid={`legal-${key}`}>
          <Link to="/" className="inline-flex items-center gap-1.5 text-[13px] text-white/55 hover:text-white mb-6">
            <ChevronLeft size={15} /> Back to home
          </Link>

          {!doc ? (
            <div className="py-20 text-center text-white/50">Document not found.</div>
          ) : (
            <>
              <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight mb-3">{doc.title}</h1>
              <p className="text-[12px] uppercase tracking-wider text-white/40 mb-8">{LEGAL_EFFECTIVE}</p>

              <div className="bb-card rounded-2xl p-6 lg:p-8">
                <p className="text-[15px] text-white/70 leading-relaxed mb-8">{doc.intro}</p>
                <div className="space-y-7">
                  {doc.sections.map((s) => (
                    <section key={s.heading}>
                      <h2 className="font-display font-semibold text-lg text-white mb-2.5">{s.heading}</h2>
                      <div className="space-y-2.5">
                        {s.body.map((para, i) => (
                          <p key={i} className="text-[14px] text-white/60 leading-relaxed">{para}</p>
                        ))}
                      </div>
                    </section>
                  ))}
                </div>
              </div>

              <div className="mt-6 flex flex-wrap gap-3 text-[13px]">
                <Link to="/terms" className="text-[#7d8eff] hover:underline">Terms of Service</Link>
                <span className="text-white/20">·</span>
                <Link to="/privacy" className="text-[#7d8eff] hover:underline">Privacy Policy</Link>
                <span className="text-white/20">·</span>
                <Link to="/risk-disclosure" className="text-[#7d8eff] hover:underline">Risk Disclosure</Link>
              </div>
            </>
          )}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Legal;
